/**
 * WelcomeStep Component
 *
 * First step of the onboarding wizard.
 * Welcomes the user and sets expectations for the setup process.
 */

import { ArrowRight, HeartHandshake } from "lucide-react";
import { Button } from "../../ui/button";
import { useAuth } from "../../../hooks/useAuth";

interface WelcomeStepProps {
  onContinue: () => void;
  isLoading: boolean;
}

export function WelcomeStep({ onContinue, isLoading }: WelcomeStepProps) {
  const { user } = useAuth();
  const displayName = user?.name?.split(" ")[0] || "there";

  return (
    <div className="text-center space-y-6 py-4">
      <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center mx-auto">
        <HeartHandshake className="w-8 h-8 text-primary" />
      </div>

      <div className="space-y-2">
        <h2 className="text-2xl font-bold text-foreground">
          Welcome to AttuneWell, {displayName}!
        </h2>
        <p className="text-muted-foreground max-w-md mx-auto">
          We're glad you're here. Let's get you set up in about 2 minutes so you
          can start understanding your relationship communication better.
        </p>
      </div>

      <Button
        size="lg"
        onClick={onContinue}
        disabled={isLoading}
        className="gap-2"
      >
        {isLoading ? "Saving..." : "Let's Go"}
        <ArrowRight className="w-4 h-4" />
      </Button>
    </div>
  );
}
